<template>
  <div class="all-question-outer">
    <div class="sign" v-if="questionData.data.content">
      <div class="cancelSign" @click="cancelSign(questionData)" v-if="questionData.form && questionData.form.is_sign == '1'">
        <img src="../../../../assets/cancelSign.png" alt="" />
        <span>取消标记</span>
      </div>
      <div class="addSign" @click="addSign(questionData)" v-else>
        <img src="../../../../assets/addSign.png" alt="" />
        <span>标记此题</span>
      </div>
    </div>
    <div class="question" v-if="questionData.data.content">
      <div class="questionTop">
        <div class="title">
          「单选题」<span class="score" v-if="questionData.data.score">{{ questionData.data.score }}分</span>
        </div>
        <!-- 试题附件展示组件 -->
        <question-files v-if="questionData.data.attachment" :attachment="questionData.data.attachment"></question-files>
        <span class="questionName">{{ questionData.data.num }}、
          <span v-html="questionData.data.content"></span>
        </span>
      </div>
      <div style="padding-top: 10px" class="radioContent">
        <a-radio-group v-model="value" @change="onChange">
          <a-radio v-for="(item, index) in questionData.data.items" :key="item.id" :style="radioStyle" :value="item.id">
            {{ String.fromCharCode(index + 65) }}、
            <div class="radio-html-box" v-html="item.content"></div>
          </a-radio>
        </a-radio-group>
      </div>
    </div>
    <div class="question" v-else>
      <div class="questionTop">
        <span class="deleted">{{ questionData.data.num }}、此题已被删除</span>
      </div>
      <div class="deleteImg">
        <img src="@/assets/deleted.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import QuestionFiles from "../questionFiles.vue";
export default {
  name: "radio",
  props: ["questionData"],
  components: { QuestionFiles },
  data () {
    return {
      value: 0,
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
    };
  },
  mounted () {
    // console.log(this.questionData);

    if (this.questionData.form.answer) {
      this.value = Number(this.questionData.form.answer);
    }

  },
  methods: {
    onChange (e) {
      this.value = e.target.value;
      this.questionData.form.answer = this.value;

    },
    //取消标记
    cancelSign (val) {
      val.form.is_sign = "2";
      this.$forceUpdate();
    },
    //标记此题
    addSign (val) {
      val.form.is_sign = "1";
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="less" scoped>
.all-question-outer {
    width: 100%;
    height: calc(100% - 60px);
    padding: 20px 50px 30px 50px;
    position: relative;
}
.sign {
    height: 32px;
    position: absolute;
    top: 35px;
    right: 50px;
}
.sign img {
    width: 30px;
    height: auto;
    margin-right: 4px;
    display: inline-block;
}
.sign span {
    line-height: 32px;
}
.cancelSign {
    float: right;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.cancelSign span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #f79e3f;
    line-height: 32px;
}
.addSign {
    float: right;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.addSign span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 32px;
}
.question .title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 32px;
}
.question .questionName {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #14202c;
    line-height: 32px;
    word-wrap: break-word;
    word-break: normal;
}
.questionTop {
    width: 100%;
    padding: 15px 0 0;
    /deep/img {
        display: block;
        max-width: 100%;
    }
    /deep/p:first-child {
        display: inline;
    }
}
.radio-html-box {
    width: 100%;
    display: inline;
    vertical-align: top;
    /deep/img {
        display: block;
        margin-bottom: 10px;
    }
}
.all-question-outer /deep/ol {
    list-style: decimal !important;
    margin-left: 15px;
}
/deep/.radioContent img {
    max-width: 90% !important;
    display: block;
    margin-top: 5px;
}
/deep/.radioContent p {
    display: inline;
}
.radioContent {
    word-wrap: break-word;
    word-break: normal;
}
/deep/.ant-radio-wrapper {
    white-space: normal;
}
.score {
    color: #9a3bec;
    font-weight: normal;
}
.deleted {
    color: #ea7e7b;
    font-size: 16px;
}
.deleteImg {
    text-align: center;
    height: 475px;
    margin-top: 140px;
}
</style>